import React from 'react'

type Props = {}

const Signup = (props: Props) => {
    return (
        <>
            
        </>
    )
}

export default Signup